import React, {Component} from 'react'
import { Button, Table } from 'reactstrap';
import {Link} from 'react-router-dom'
import { Trans } from "react-i18next";

class MainInfo extends Component{

    constructor(props) {
	super(props);
    }
    
    
    render(){	
	const {main_info} = this.props
	const keys = ['fiscal_code', 'euvat','address', 'city', 'postal_code', 'country_description_en', 'legal_form_description_en', 'registration_date', 'status_description_en', 'ateco_sector_code', 'ateco_sector_description_en', 'email', 'website', 'pec']
	
	return <Table striped>
	    <tbody>
		{keys.map(k=>
		    <tr key={k}>
			<td>{<Trans>companies.main_info.{k}</Trans>}</td>
			<td>{main_info[k]}</td>
		    </tr>)}
	    </tbody>
	</Table>
    }
}

MainInfo.defaultProps = {
    main_info: {}
}
export default MainInfo
